import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { PDP_SELECTION_VALIDITY_STATES, PDP_DECIDELATER_TAB_ID, PDP_CUSTOMIZE_TAB_ID, PDP_READYTOSHIP_TAB_ID } from 'commons/constants';
import useCart from 'data-hooks/useCart';
import usePDPFabricFilters from 'data-hooks/usePDPFabricFilters';
import useProductFavoriteV2 from 'data-hooks/useProductFavoriteV2';
import useUserCartEvent from 'data-hooks/useEvents/useUserCartEvent';
import useModularDetails from 'data-hooks/useModularDetails';
import useModularPDPCart from 'data-hooks/useModularPDPCart';
import { getCombinedOptionSKUs } from 'data-hooks/useProductLocalStock/utils';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import useIsZipCodeFromUserServiceable from 'global-state/isZipCodeFromUserServiceable/useIsZipCodeFromUserServiceable';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPPrice from 'data-hooks/usePDPPrice';
import { getPriceDetailsUtil } from 'data-hooks/utils';
import useJbEventFBAddToCart from 'hooks/sendFBEventHooks/useJbEventFBAddToCart';
import lastInsightsClickAtom from 'components/consumer/consumer-search/advanced-search/atoms/lastInsightsClickAtom';
import { useAtom } from 'jotai';
import handleInsightsAddToCart from 'components/consumer/consumer-search/algolia-insights-helpers/handleInsightsAddtoCart';
import { getDisplayedInsightsPricing } from 'components/consumer/consumer-search/algolia-insights-helpers/insightsObjectDataUtils';
import PDPAddToBagSectionUI from './PDPAddToBagSectionUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
import usePdpSelectedCustomizerTab from '../state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePdpSelectedProtectionPlanId from '../state/pdpSelectedProtectionPlanId/usePdpSelectedProtectionPlanId';
import usePDPOptions from '../state/context/usePDPOptions';
import usePDPStockAvailability from '../state/context/usePDPStockAvailability';
import PDPAddToBagSectionPlaceholder from './PDPAddToBagSectionPlaceholder';
const PDPAddToBagSectionInner = t0 => {
  const $ = _c(59);
  const {
    mode: t1,
    onAddToCartClicked,
    pageLoading,
    productId: t2,
    slug: t3,
    stickyDesktopButtonOnly: t4,
    forceStickyVisible: t5,
    isEditOrder: t6,
    keepAddToBagLabel: t7
  } = t0;
  const mode = t1 === undefined ? "pdp" : t1;
  const productId = t2 === undefined ? null : t2;
  const slug = t3 === undefined ? null : t3;
  const stickyDesktopButtonOnly = t4 === undefined ? false : t4;
  const forceStickyVisible = t5 === undefined ? false : t5;
  const isEditOrder = t6 === undefined ? false : t6;
  const keepAddToBagLabel = t7 === undefined ? false : t7;
  const [addToCartError, setAddToCartError] = useState(null);
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {};
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  const [buildYourOwnDetails, updateBuildYourOwnDetails] = useState(t8);
  const [lastInsightsClick] = useAtom(lastInsightsClickAtom);
  const {
    isFavorited
  } = useProductFavoriteV2();
  const {
    data: priceData
  } = usePDPPrice();
  const isZipCodeFromUserServiceable = useIsZipCodeFromUserServiceable();
  const {
    loading: basicDetailsLoading,
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    loading: modularDetailsLoading,
    data: modularDetailsData
  } = useModularDetails(slug);
  const {
    data: t9,
    actions: t10
  } = useModularPDPCart(productId, slug);
  const {
    addingToCart: modularAddingToCart,
    modularTotalPrice
  } = t9;
  const {
    addModularToCart
  } = t10;
  const {
    loading: optionsLoading,
    data: optionData
  } = usePDPOptions();
  const {
    loading: availabilityLoading,
    data: t11
  } = usePDPStockAvailability();
  const {
    isEFGInternal,
    isMarkedOOSOrDiscontinued,
    isOutOfStock,
    isDiscontinued
  } = t11;
  const {
    data: t12,
    actions: t13
  } = useCart();
  const {
    addingToCart
  } = t12;
  const {
    addToCart
  } = t13;
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  const {
    data: t14
  } = usePDPFabricFilters(slug, isEditOrder);
  const {
    selectedMaterial
  } = t14;
  let t15;
  if ($[1] !== priceData) {
    t15 = priceData || {};
    $[1] = priceData;
    $[2] = t15;
  } else {
    t15 = $[2];
  }
  const {
    isClearance,
    clearanceStockPerSKU
  } = t15;
  const isDecideLaterTab = pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID;
  const isRTSTab = pdpSelectedCustomizerTab === PDP_READYTOSHIP_TAB_ID;
  let t16;
  bb0: {
    if (!priceData?.price) {
      let t17;
      if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = {
          price: 0,
          discount: 0
        };
        $[3] = t17;
      } else {
        t17 = $[3];
      }
      t16 = t17;
      break bb0;
    }
    let t17;
    if ($[4] !== priceData.isClearance || $[5] !== priceData.optionPrice || $[6] !== priceData.price || $[7] !== priceData.promotion) {
      t17 = getDisplayedInsightsPricing(getPriceDetailsUtil(priceData.price, priceData.promotion, priceData.optionPrice, priceData.isClearance));
      $[4] = priceData.isClearance;
      $[5] = priceData.optionPrice;
      $[6] = priceData.price;
      $[7] = priceData.promotion;
      $[8] = t17;
    } else {
      t17 = $[8];
    }
    t16 = t17;
  }
  const insightsPricing = t16;
  const {
    addToCartEvent
  } = useUserCartEvent(basicDetails, optionData, priceData, isClearance, isFavorited);
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const pdpSelectedProtectionPlanId = usePdpSelectedProtectionPlanId();
  let t17;
  if ($[9] !== addModularToCart || $[10] !== addToCart || $[11] !== addToCartEvent || $[12] !== basicDetails || $[13] !== insightsPricing || $[14] !== lastInsightsClick || $[15] !== mode || $[16] !== onAddToCartClicked || $[17] !== optionData.selectedOptions || $[18] !== pdpIsModularBYOProduct || $[19] !== pdpSelectedCustomizerTab || $[20] !== pdpSelectedProtectionPlanId) {
    t17 = async () => {
      if (pdpIsModularBYOProduct) {
        addModularToCart({
          decideLater: pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID
        });
        return;
      }
      setAddToCartError(null);
      const {
        errors,
        cart,
        cartToken
      } = await addToCart({
        productId: basicDetails.id,
        selectedOptions: optionData.selectedOptions,
        decideLater: pdpSelectedCustomizerTab === PDP_DECIDELATER_TAB_ID,
        selectedProtectionPlanId: pdpSelectedProtectionPlanId
      });
      if (errors) {
        setAddToCartError(errors?.[0]?.message || "Unable to add to cart. Please try again.");
        return;
      }
      handleInsightsAddToCart({
        hit: lastInsightsClick,
        productId: basicDetails.id,
        price: insightsPricing.price,
        discount: insightsPricing.discount,
        quantity: 1
      });
      onAddToCartClicked?.();
      addToCartEvent(cart, cartToken, mode);
    };
    $[9] = addModularToCart;
    $[10] = addToCart;
    $[11] = addToCartEvent;
    $[12] = basicDetails;
    $[13] = insightsPricing;
    $[14] = lastInsightsClick;
    $[15] = mode;
    $[16] = onAddToCartClicked;
    $[17] = optionData.selectedOptions;
    $[18] = pdpIsModularBYOProduct;
    $[19] = pdpSelectedCustomizerTab;
    $[20] = pdpSelectedProtectionPlanId;
    $[21] = t17;
  } else {
    t17 = $[21];
  }
  const onAddToCart = t17;
  let t18;
  let t19;
  if ($[22] !== isZipCodeFromUserServiceable) {
    t18 = () => {
      if (isZipCodeFromUserServiceable) {
        setAddToCartError(null);
      }
    };
    t19 = [isZipCodeFromUserServiceable];
    $[22] = isZipCodeFromUserServiceable;
    $[23] = t18;
    $[24] = t19;
  } else {
    t18 = $[23];
    t19 = $[24];
  }
  useEffect(t18, t19);
  let t20;
  bb1: {
    if (availabilityLoading || optionsLoading || modularDetailsLoading) {
      t20 = false;
      break bb1;
    }
    if (isEFGInternal || isEmpty(optionData?.options) || optionData?.pdpHasUserSelectedOptions || !optionData?.upholsteryOptionId || pdpSelectedCustomizerTab !== PDP_CUSTOMIZE_TAB_ID || optionData?.options.find(optValue => optValue.id === optionData?.upholsteryOptionId)?.values?.length === 1) {
      t20 = false;
      break bb1;
    }
    t20 = true;
  }
  const allowUserToCustomize = t20;
  let t21;
  bb2: {
    if (!!optionData.stock?.stockOptionsCombined?.length && isRTSTab) {
      const updatedDisabledState = getCombinedOptionSKUs(optionData.selectedOptionsVariantSku, optionData.stock?.stockOptionsCombined);
      t21 = updatedDisabledState;
      break bb2;
    }
    t21 = [];
  }
  const validStockOptionSkus = t21;
  let t22;
  bb3: {
    if (availabilityLoading || optionsLoading) {
      t22 = false;
      break bb3;
    }
    if (validStockOptionSkus?.length && optionData?.selectedOptionsVariantSku) {
      if (!validStockOptionSkus.includes(optionData?.selectedOptionsVariantSku)) {
        t22 = true;
        break bb3;
      }
    }
    if (!optionData?.stock?.stockOptions?.length || isOutOfStock) {
      t22 = isOutOfStock;
      break bb3;
    }
    const {
      selectionValidity
    } = optionData.stock;
    let t23;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = [PDP_SELECTION_VALIDITY_STATES.INVALID, PDP_SELECTION_VALIDITY_STATES.INACTIVE];
      $[25] = t23;
    } else {
      t23 = $[25];
    }
    t22 = t23.includes(selectionValidity);
  }
  const isCartDisabled = t22;
  let t23;
  if ($[26] !== basicDetails?.id || $[27] !== basicDetails?.meta?.collectionSlug || $[28] !== modularDetailsData.isModularBundleProduct || $[29] !== modularDetailsData.preConfigProducts) {
    t23 = () => {
      if (!modularDetailsData?.isModularBundleProduct || !modularDetailsData?.preConfigProducts?.length) {
        return;
      }
      const updatedProducts = modularDetailsData.preConfigProducts.filter(prod => !!prod && prod.id !== basicDetails?.id);
      let finalSlug = basicDetails?.meta?.collectionSlug ? basicDetails?.meta?.collectionSlug.replace("collections/", "") : "";
      finalSlug = finalSlug.length ? `${finalSlug.charAt(0).toUpperCase()}${finalSlug.slice(1)}` : "";
      updateBuildYourOwnDetails({
        name: finalSlug,
        urlKey: `/modular/${finalSlug.toLowerCase()}-modular/`,
        dimensions: `Choose from ${updatedProducts.length} pieces to make any configuration.`
      });
    };
    $[26] = basicDetails?.id;
    $[27] = basicDetails?.meta?.collectionSlug;
    $[28] = modularDetailsData.isModularBundleProduct;
    $[29] = modularDetailsData.preConfigProducts;
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  const t24 = basicDetails?.id;
  const t25 = basicDetails?.meta?.collectionSlug;
  const t26 = modularDetailsData?.isModularBundleProduct;
  let t27;
  if ($[31] !== modularDetailsData.preConfigProducts || $[32] !== t24 || $[33] !== t25 || $[34] !== t26) {
    t27 = [t24, t25, t26, modularDetailsData.preConfigProducts];
    $[31] = modularDetailsData.preConfigProducts;
    $[32] = t24;
    $[33] = t25;
    $[34] = t26;
    $[35] = t27;
  } else {
    t27 = $[35];
  }
  useEffect(t23, t27);
  const t28 = optionData?.selectedOptionsVariantSku;
  let t29;
  if ($[36] !== basicDetails || $[37] !== t28) {
    t29 = {
      basicDetails,
      selectedOptionsVariantSku: t28
    };
    $[36] = basicDetails;
    $[37] = t28;
    $[38] = t29;
  } else {
    t29 = $[38];
  }
  useJbEventFBAddToCart(t29);
  const loading = basicDetailsLoading || optionsLoading || pageLoading || modularDetailsLoading;
  const t30 = pdpIsModularBYOProduct ? modularAddingToCart : addingToCart;
  const t31 = loading || isCartDisabled || pdpIsModularBYOProduct && !modularTotalPrice || isMarkedOOSOrDiscontinued && (isOutOfStock || isDiscontinued);
  const t32 = basicDetails?.meta?.collectionSlug;
  const t33 = modularDetailsData?.isModularBundleProduct;
  const t34 = !loading ? onAddToCart : undefined;
  const t35 = basicDetails?.meta?.price?.final_price;
  const t36 = isClearance && !clearanceStockPerSKU?.flashSale && !isDecideLaterTab;
  const t37 = basicDetails?.custom_properties?.campaign;
  let t38;
  if ($[39] !== addToCartError || $[40] !== allowUserToCustomize || $[41] !== buildYourOwnDetails || $[42] !== forceStickyVisible || $[43] !== isDiscontinued || $[44] !== isOutOfStock || $[45] !== keepAddToBagLabel || $[46] !== loading || $[47] !== mode || $[48] !== selectedMaterial || $[49] !== stickyDesktopButtonOnly || $[50] !== t30 || $[51] !== t31 || $[52] !== t32 || $[53] !== t33 || $[54] !== t34 || $[55] !== t35 || $[56] !== t36 || $[57] !== t37) {
    t38 = <PDPAddToBagSectionUI addToCartError={addToCartError} addingToCart={t30} allowUserToCustomize={allowUserToCustomize} buildYourOwnDetails={buildYourOwnDetails} cartDisabled={t31} collectionSlug={t32} isDiscontinued={isDiscontinued} isModularBundleProduct={t33} isOutOfStock={isOutOfStock} loading={loading} mode={mode} onAddToCart={t34} price={t35} showClearanceAlert={t36} stickyDesktopButtonOnly={stickyDesktopButtonOnly} forceStickyVisible={forceStickyVisible} keepAddToBagLabel={keepAddToBagLabel} campaign={t37} selectedMaterial={selectedMaterial} />;
    $[39] = addToCartError;
    $[40] = allowUserToCustomize;
    $[41] = buildYourOwnDetails;
    $[42] = forceStickyVisible;
    $[43] = isDiscontinued;
    $[44] = isOutOfStock;
    $[45] = keepAddToBagLabel;
    $[46] = loading;
    $[47] = mode;
    $[48] = selectedMaterial;
    $[49] = stickyDesktopButtonOnly;
    $[50] = t30;
    $[51] = t31;
    $[52] = t32;
    $[53] = t33;
    $[54] = t34;
    $[55] = t35;
    $[56] = t36;
    $[57] = t37;
    $[58] = t38;
  } else {
    t38 = $[58];
  }
  return t38;
};
PDPAddToBagSectionInner.propTypes = {
  mode: PropTypes.oneOf(['quickview', 'pdp']),
  onAddToCartClicked: PropTypes.func,
  pageLoading: PropTypes.bool,
  productId: PropTypes.number,
  slug: PropTypes.string,
  stickyDesktopButtonOnly: PropTypes.bool,
  // The layout revamp's summary bar decides visibility itself
  forceStickyVisible: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  keepAddToBagLabel: PropTypes.bool
};
const PDPAddToBagSection = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPAddToBagSectionPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPAddToBagSectionInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPAddToBagSection;